export default {
  name: "EditFeature",
  props: {
    editedFeature: Object,
    global: Boolean,
    showCancel: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    permissions: [
      { id: "all", title: "Alle" },
      { id: "poi_admin", title: "POI Administrator" },
      { id: "admin", title: "OYA Admin" },
      { id: "region_edit", title: "Regionen Edit" },
      { id: "regions_admin", title: "Regionen Admin" }
    ]
  })
};
